// export const mpAppId = 'wx586e3a736596899c'
// export const mpRedirectUrl = 'http://127.0.0.1:8080/#/'
export const mpAppId = "wx384f3fd3153b2ae3";
export const mpRedirectUrl = `https://${window.location.host}/#/`;
